export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "product__prepurchase--bullet1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sold as-is for a super sweet discount"])},
        "product__prepurchase--bullet2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ships *free* in your next Nuuly"])},
        "product__prepurchase--bullet3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doesn’t take up a rental spot"])},
        "product__prepurchase--learnMoreCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Learn More"])},
        "product__prepurchase--exploreRentingCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rent Instead"])}
      }
    }
  })
}
